// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"f43d228b","127":"d43234a8","256":"671b715d","262":"80687885","360":"fe2f65ff","453":"dbe1b060","557":"00363362","564":"0aad80d6","642":"90d41e3c","644":"a8f46c74","755":"88c3db00","824":"d8b063aa","939":"ade2f22f","998":"c96abf41"}[chunkId] + ".chunk.js";
};